export const APP_NAME = "tagworx-user";
export const defaultLanguage = "en";
